import { Link } from 'react-router-dom';
import { Icons } from '@/src/modules/components/Icons';
import type { ConfirmedPurchase } from '../api';

/**
 * Tells the user a payment we just confirmed (e.g. its checkout page was lost
 * before Razorpay's success callback) — and where to finish: publish the
 * invitation it was bought for, or create one for a catalog purchase.
 */
export function PendingPaymentsBanner({
  confirmed,
  onDismiss,
}: {
  confirmed: ConfirmedPurchase[];
  onDismiss: () => void;
}) {
  if (confirmed.length === 0) return null;
  const orders = confirmed.map((c) => c.orderNumber).join(', ');
  const forInvitation = confirmed.some((c) => c.invitationId);

  return (
    <div
      role="status"
      className="mx-4 mt-4 md:mx-8 rounded-2xl border border-status-published/30 bg-status-published/10 px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3 text-sm"
    >
      <Icons.CheckCircle size={18} className="text-status-published flex-shrink-0" />
      <p className="flex-1 text-on-surface">
        <span className="font-bold">Payment confirmed</span> for {orders}.{' '}
        {forInvitation
          ? 'Your invitation is paid and ready to publish.'
          : 'Your publish credit is ready — create an invitation with this design.'}
      </p>
      <div className="flex items-center gap-2">
        <Link
          to={forInvitation ? '/dashboard/invitations?tab=pending_publish' : '/wizard'}
          className="rounded-xl bg-primary px-3 py-1.5 font-bold text-white"
        >
          {forInvitation ? 'Publish now' : 'Create invitation'}
        </Link>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="rounded-xl px-2 py-1.5 text-on-surface-variant hover:text-on-surface"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
